function locationDataReducer(state = { provinceList: [], cityList: [], zoneList: [] }, action)
{
switch (action.type) {
    case "FETCH_DATA_PROVINCE":        
        return {
            ...state,
            provinceList: action.data
        };
    case "FETCH_DATA_CITY_LIST":
        return {
            ...state,
            cityList: action.data
        };
    case "FETCH_DATA_ZONE_LIST":
        return {
            ...state,
            zoneList:action.data
        }
        case "SET_CURRENT_LOCATION":
            return {
                ...state,
                currentLocation: action.data
            }        

    default:
        return state;
}
}
export default locationDataReducer;